import { useQuery } from '@tanstack/react-query';
import { stepEditRequestCount } from '../api/candidates';
import { usePermission } from '../auth/usePermission';

export const STEP_EDIT_REQUESTS_QUERY_KEY = ['pending-step-edit-requests'];

/** Pending step-edit request count for the sidebar badge (polled, like useStepSubmissionCount). */
export function useStepEditCount() {
  const { can } = usePermission();
  const enabled = can('approve edit candidate completed step');

  const query = useQuery({
    queryKey: [...STEP_EDIT_REQUESTS_QUERY_KEY, 'count'],
    queryFn: stepEditRequestCount,
    enabled,
    refetchInterval: 60_000,
  });

  return enabled ? (query.data ?? 0) : 0;
}
